{
  "CHAT_LIST": {
    "LOADING": "Recupero delle conversazioni",
    "LOAD_MORE_CONVERSATIONS": "Carica altre conversazioni",
    "EOF": "Tutte le conversazioni caricate 🎉",
    "LIST": {
      "404": "Non ci sono conversazioni attive in questo gruppo."
    },
    "FAILED_TO_SEND": "Failed to send",
    "TAB_HEADING": "Conversazioni",
    "MENTION_HEADING": "Menzioni",
    "UNATTENDED_HEADING": "Non partecipate",
    "SEARCH": {
      "INPUT": "Cerca persone, Chat, risposte salvate .."
    },
    "SEARCH_MESSAGES": "Cerca conversazioni",
    "SEARCH_INPUT_PLACEHOLDER": "Cerca conversazioni...",
    "FILTER_ALL": "Tutti",
    "ASSIGNEE_TYPE_TABS": {
      "me": "Mie",
      "unassigned": "Non assegnate",
      "all": "Tutti"
    },
    "MESSAGE_USE_AS_TEMPLATE": "Incolla nella risposta",
    "CARDS": {
      "ACTIONS": {
        "OPEN": "Apri",
        "BUY": "Acquista"
      }
    },
    "CHAT_STATUS_FILTER_ITEMS": {
      "open": {
        "TEXT": "Aperte"
      },
      "resolved": {
        "TEXT": "Risolti"
      },
      "pending": {
        "TEXT": "In sospeso"
      },
      "snoozed": {
        "TEXT": "Posticipato"
      },
      "all": {
        "TEXT": "Tutti"
      }
    },
    "VIEW_FILTER": "Visualizza",
    "SORT_TOOLTIP_LABEL": "Sort conversations",
    "CHAT_SORT": {
      "STATUS": "Stato",
      "ORDER_BY": "Order by"
    },
    "CHAT_TIME_STAMP": {
      "CREATED": "Created",
      "LAST_ACTIVITY": "Last activity:",
      "LAST_CUSTOMER_MESSAGE": "Ultimo messaggio del cliente:"
    },
    "SORT_ORDER_ITEMS": {
      "last_activity_at_asc": {
        "TEXT": "Last activity: Oldest first"
      },
      "last_activity_at_desc": {
        "TEXT": "Last activity: Newest first"
      },
      "last_customer_message_at_asc": {
        "TEXT": "Ultimo messaggio del cliente: meno recenti prima"
      },
      "last_customer_message_at_desc": {
        "TEXT": "Ultimo messaggio del cliente: più recenti prima"
      },
      "created_at_desc": {
        "TEXT": "Created at: Newest first"
      },
      "created_at_asc": {
        "TEXT": "Created at: Oldest first"
      },
      "priority_desc": {
        "TEXT": "Priority: Highest first"
      },
      "priority_asc": {
        "TEXT": "Priority: Lowest first"
      },
      "priority_created_at_desc": {
        "TEXT": "Priorità + Data creazione: più recenti prima"
      },
      "priority_created_at_asc": {
        "TEXT": "Priorità + Data creazione: meno recenti prima"
      },
      "waiting_since_asc": {
        "TEXT": "Pending Response: Longest first"
      },
      "waiting_since_desc": {
        "TEXT": "Pending Response: Shortest first"
      }
    },
    "ATTACHMENTS": {
      "image": {
        "CONTENT": "Messaggio immagine"
      },
      "audio": {
        "CONTENT": "Messaggio audio"
      },
      "video": {
        "CONTENT": "Messaggio video"
      },
      "file": {
        "CONTENT": "File allegato"
      },
      "location": {
        "CONTENT": "Posizione"
      },
      "ig_reel": {
        "CONTENT": "Instagram Reel"
      },
      "fallback": {
        "CONTENT": "ha condiviso un url"
      },
      "contact": {
        "CONTENT": "Shared contact"
      }
    },
    "CHAT_SORT_BY_FILTER": {
      "TITLE": "Sort conversation",
      "DROPDOWN_TITLE": "Ordina per",
      "ITEMS": {
        "LATEST": {
          "NAME": "Last activity at",
          "LABEL": "Last activity"
        },
        "CREATED_AT": {
          "NAME": "Creato il",
          "LABEL": "Creato il"
        },
        "LAST_USER_MESSAGE_AT": {
          "NAME": "Last user message at",
          "LABEL": "Last message"
        }
      }
    },
    "RECEIVED_VIA_EMAIL": "Ricevuto via email",
    "VIEW_TWEET_IN_TWITTER": "Visualizza tweet su Twitter",
    "REPLY_TO_TWEET": "Rispondi a questo tweet",
    "LINK_TO_STORY": "Vai alla storia di instagram",
    "SENT": "Inviato correttamente",
    "READ": "Read successfully",
    "DELIVERED": "Delivered successfully",
    "NO_MESSAGES": "Nessun messaggio",
    "NO_CONTENT": "Nessun contenuto disponibile",
    "HIDE_QUOTED_TEXT": "Nascondi testo citato",
    "SHOW_QUOTED_TEXT": "Mostra testo citato",
    "HIDE_AUTOMATED_MESSAGE": "Nascondi contenuto delle risposte automatiche",
    "SHOW_AUTOMATED_MESSAGE": "Mostra contenuto delle risposte automatiche",
    "AUTOMATED_MESSAGE": "Risposta automatica",
    "MESSAGE_READ": "Leggi",
    "SENDING": "Sending"
  }
}
